import { MOODY_RATINGS, RatingAgency, SP_RATINGS } from "@goodfill/domain-properties";
import { PricedBond } from "../../PricedBond";

const createRatingsComparator = (referenceArray: readonly string[]) => (a: string, b: string) =>
  referenceArray.indexOf(a) - referenceArray.indexOf(b);

export const moodysRatingComparator = createRatingsComparator(MOODY_RATINGS);
export const spRatingComparator = createRatingsComparator(SP_RATINGS);

export function findAllPossibleSortedRatingsValuesAmongBonds(
  pricedBonds: PricedBond[],
  ratingAgency: RatingAgency,
): string[] {
  const result = Array.from(
    new Set(
      pricedBonds.reduce((acc, pricedBond) => {
        const rating = ratingAgency === "moodys" ? pricedBond.ratings.moodys : pricedBond.ratings.sp;
        if (rating !== null) {
          acc.push(rating);
        }

        return acc;
      }, [] as string[]),
    ),
  );

  result.sort(ratingAgency === "moodys" ? moodysRatingComparator : spRatingComparator);
  result.reverse(); // lowest on left, highest on right of x axis

  return result;
}
